/**
 * ProjectAuditLogService
 * Service for ProjectAuditLog entity operations
 * Route: api/project-audit-logs
 * Controller: ProjectAuditLogController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectAuditLogService
 * Handles project audit log CRUD operations
 * Maps to /api/project-audit-logs endpoint
 */
export class ProjectAuditLogService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectAuditLogService.DEFAULT_SERVICE_PATH,
            basePath: ProjectAuditLogService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectAuditLogService.DEFAULT_SERVICE_PATH = 'projects';
ProjectAuditLogService.BASE_PATH = 'api/project-audit-logs';
//# sourceMappingURL=ProjectAuditLogService.js.map